import AttachablePanel from '@/lib/printess/attachablePanel'

export const DuvelMoortgatBeerMixin = (Base) =>
  class extends Base {
    #duvelMoortgatBeerEditor
    #duvelMoortgatBeerEditorPanel

    onEditorLoaded() {
      super.onEditorLoaded()

      this.#connectDuvelMoortgatBeerEditor()
    }

    // called from the bridge
    editDuvelMoortgatBeer() {
      this.#duvelMoortgatBeerEditorPanel.show()
    }

    // called from stimulus (button click)
    hideEditDuvelMoortgatBeerEditor() {
      this.#duvelMoortgatBeerEditorPanel.hide()
    }

    // called from base
    disconnectDuvelMoortgatBeer() {
      const editorDataInput = document.getElementById("product_personalization_editor_data")
      if (editorDataInput && this._onEditorDataChangeUpdateDuvelMoortgatBeer) {
        editorDataInput.removeEventListener('change', this._onEditorDataChangeUpdateDuvelMoortgatBeer)
      }

      if (!this.#duvelMoortgatBeerEditorPanel) return
      this.#duvelMoortgatBeerEditorPanel.detach()
    }

    // called from base
    updateDuvelMoortgatBeer() {
      if (!this.editorReady || !this.#duvelMoortgatBeerEditor) { return; }

      const editorDataInput = document.getElementById("product_personalization_editor_data")
      let data
      try {
        data = JSON.parse(editorDataInput.value)
      } catch (e) {
        return
      }

      const records = data || []

      const dfBeers = records.filter(b => /^duvel/.test(b.subcategory_param) )
      const mappedDfBeers = dfBeers.map(this.#mapDfBeer)

      const otherBeers = records.filter(b => /^other/.test(b.subcategory_param))
      const mappedOtherBeers = otherBeers.map(this.#mapDfOtherBeer)

      console.log(mappedDfBeers);
      console.log(mappedOtherBeers);

      Promise.all([
        this.editor.api.setFormFieldValue('dfBeer', JSON.stringify(mappedDfBeers)),
        this.editor.api.setFormFieldValue('otherBeer', JSON.stringify(mappedOtherBeers)),
      ]).then(() => {
        this.editor.api.clearSelection();
      });
    }

    #connectDuvelMoortgatBeerEditor() {
      this._onEditorDataChangeUpdateDuvelMoortgatBeer = this.updateDuvelMoortgatBeer.bind(this)

      const editorDataInput = document.getElementById("product_personalization_editor_data")

      if (editorDataInput) {
        editorDataInput.addEventListener('change', this._onEditorDataChangeUpdateDuvelMoortgatBeer)
      }

      this.#initDuvelMoortgatBeerEditor();
    }

    #initDuvelMoortgatBeerEditor() {
      this.#duvelMoortgatBeerEditor = document.getElementById('duvel_moortgat_beer_editor');

      if (!this.#duvelMoortgatBeerEditor) return

      this.#duvelMoortgatBeerEditorPanel = new AttachablePanel(this.editor, this.#duvelMoortgatBeerEditor);
      this.#duvelMoortgatBeerEditorPanel.attach()
    }

    #mapDfBeer(beer) {
      return {
        packshot: beer.visual_url,
        productname: beer.name,
        alcohol: beer.alcohol_by_volume,
        description: beer.description,
        subcategory: beer.subcategory,

        price: beer.price1,
        volume: beer.volume1,
        unit: beer.unit1,
        happy_hour: beer.happy_hour1,
        price_2: beer.price2,
        volume_2: beer.volume2,
        unit_2: beer.unit2,
        happy_hour_2: beer.happy_hour2,
        price_3: beer.price3,
        volume_3: beer.volume3,
        unit_3: beer.unit3,
        happy_hour_3: beer.happy_hour3,
      }
    }

    #mapDfOtherBeer(beer) {
      return {
        productname: beer.name,
        alcohol: beer.alcohol_by_volume,

        price: beer.price1,
        volume: beer.volume1,
        unit: beer.unit1,
        price_2: beer.price2,
        volume_2: beer.volume2,
        unit_2: beer.unit2,
        price_3: beer.price3,
        volume_3: beer.volume3,
        unit_3: beer.unit3,
      }
    }
  };
